import { Component, OnInit } from '@angular/core';

@Component({
  template: `<h1>Whoops!</h1><p>Sorry, but it looks like the page you've requested couldn't be found.  Please make sure that you've typed the address correctly.</p>`
})
export class NotFoundComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
